<template>
    <div class="ur-data-grid__info-item ur-data-grid__action__button-area" v-if="showArea">
        <ur-button small @click="btnAdd" v-if="gridInfo.opts.authCreate">{{msgAdd}}</ur-button>
        <ur-button small @click="btnDel" v-if="gridInfo.opts.authRemove" :disabled="selCnt===0">{{msgDel}}</ur-button>
    </div>
</template>

<script>
import {CONST} from '../../config'
export default {
    name : "urDataGridInfoModuleCellActButton",
    inject : ['gridInfo'],
    computed : {
        // [COMPUTED] Button
        showArea() {
            return this.gridInfo.opts.authCreate
                || this.gridInfo.opts.authRemove;
        },
        // [COMPUTED] Values
        selCnt() {return this.gridInfo.vars_selLen},
        // [COMPUTED] messages
        msgAdd() {return this.gridInfo.opts.msgBtnAdd},
        msgDel() {return this.gridInfo.opts.msgBtnDelete},
    },
    methods : {
        // [METHODS] btnAdd : Make temp row to add new Item
        btnAdd() {
            this.gridInfo.func.cancelCell();
            this.gridInfo.func.createEmptyRow();
        },
        // [METHODS] btnDel : Remove selected data
        btnDel() {
            var rows = this.gridInfo.sels;
            const BD = this.gridInfo.opts.blockDelete;
            if(BD) {
                const FLAG = CONST.VAL.DIRTY.FLAG.CREATE;
                const nRows = rows.filter(row => {
                    if(typeof BD === 'function') {
                        return BD(row);
                    } else {
                        return row.__dirty === FLAG
                    }
                });
                if(nRows.length !== rows.length && nRows.length === 0) {
                    console.warn('[UIDev] blockDelete option is activate. Cannot remove rows.')
                }
                this.gridInfo.func.removeRows(nRows);
            } else {
                this.gridInfo.func.removeRows(rows);
            }
        },
    }
}

</script>